import React from "react";
import { Field, useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { Input } from "components/bootstrap";
import { Select } from "components/common";
import { DATA_LAKE_INCLUSION_TYPE, INDEXER_INCLUSION_TYPE, BOTH_INCLUSION_TYPE } from "data-lake/Constants";
const INCLUSION_TYPE_OPTIONS = [
  { value: DATA_LAKE_INCLUSION_TYPE, label: "inclusion_type.must_exclude" },
  { value: INDEXER_INCLUSION_TYPE, label: "inclusion_type.must_include" },
  { value: BOTH_INCLUSION_TYPE, label: "inclusion_type.include_all" }
];
const InclusionTypeField = () => {
  const { t } = useTranslation("enterprise_data_lake");
  const {
    errors,
    setFieldValue,
    values: { inclusionType }
  } = useFormikContext();
  return /* @__PURE__ */ React.createElement(Field, { name: "inclusion_type" }, () => /* @__PURE__ */ React.createElement(
    Input,
    {
      help: t("inclusion_type.help"),
      id: "inclusion-type",
      error: errors.inclusionType,
      label: t("inclusion_type.label")
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        id: "inclusionType",
        name: "inclusionYype",
        placeholder: t("inclusion_type.placeholder"),
        options: INCLUSION_TYPE_OPTIONS.map((option) => ({ ...option, label: t(option.label) })),
        onChange: (option) => {
          setFieldValue("inclusionType", option);
        },
        value: inclusionType
      }
    )
  ));
};
export default InclusionTypeField;
